import { ProjectAnalysesSectionPage } from '@/pages/ProjectAnalysesSectionPage';

export function ProjectAnalysesPuissancePage() {
  return <ProjectAnalysesSectionPage sectionTitle="Puissance" />;
}

